export default "/images/stop.svg"